import {DateTabsType, SportFilter} from 'utils/types';
import {useCallback, useEffect} from 'react';
import {SportFilterState} from 'store/sportFilter/types';
import setDateTabsThunk from 'store/dateTabs/actions/setDateTabs';
import setSelectedDateTabThunk from 'store/dateTabs/actions/setSelectedDateTab';
import {useDispatch, useSelector} from 'react-redux';
import {AppState} from 'store/types';
import setSportFilterThunk from 'store/sportFilter/actions/setSportFilter';
import {dateTabsTotal, getDateTabs} from 'store/dateTabs/utils';
import {sportNames} from 'utils/sportsUtils';

// BIQ: tabs creation logic should maybe go into store action?
// TODO: complete documentation

type UseSportFilterHook = [
  SportFilterState,
  {
    setSportFilter: (f: string) => void;
  }
];

const sportFilterSelector = (state: AppState): SportFilterState => ({
  filter: state.sportFilter.filter ?? 'top',
});

const useSportFilter = (): UseSportFilterHook => {
  const dispatch = useDispatch();
  const state = useSelector(sportFilterSelector);
  const {filter} = state;

  const setSportFilter = useCallback(
    (sportFilter: string) => {
      let f = sportFilter;
      if (!['top', ...sportNames.map(s => s.sport)].includes(sportFilter)) f = 'top';
      return dispatch(setSportFilterThunk(f as SportFilter));
    },
    [dispatch]
  );

  return [state, {setSportFilter}];
};

export default useSportFilter;
